import dayjs from 'dayjs'
import { InputFieldBase } from '../Fields/types'
import { FieldType } from './fieldTypeEnum'
import hashString from '../../../utils/hashString'

export const transformPayload = (
  data: { [x: string]: any },
  fields: InputFieldBase[],
  simpleCvr = false,
): { [x: string]: any } => {
  const formPayload: { [x: string]: any } = {}

  // filter off confirmation fields
  const filteredData = Object.fromEntries(Object.entries(data).filter(([key]) => !key.startsWith('confirmation-')))

  Object.keys(filteredData).forEach(item => {
    const field = fields.find(field => field.name === item && field.fieldType)

    if (!field) return (formPayload[item] = data[item])
    formPayload[item] = data[item]
    if (field.fieldType === FieldType.DATEPICKER) {
      formPayload[item] = dayjs(data[item]).format('DD/MM/YYYY')
    }
    if (field.fieldType === FieldType.TIMEPICKER) {
      formPayload[item] = dayjs(data[item]).format('HH:mm')
    }
    if (field.fieldType === FieldType.PASSWORD) {
      formPayload[item] = hashString.encrypt(data[item], process.env.GATSBY_HASH_SECRET)
    }
    if (simpleCvr && field.fieldType === FieldType.CVR) {
      formPayload[item] = data[item]['cvrNumber']
    }
  })

  return formPayload
}
